import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HeartFillIcon, HeartIcon } from '@yonderland/andes-icons';
import { Badge, Breakpoint, IconLink } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePageShow } from '../../hooks/usePageShow';
import { wishListActions } from '../../redux/wishList/actions/WishListActions.creators';
import { makeGetWishlistCounter } from '../../redux/wishList/selectors/WishListSelectors';
const WishListMenuItem = ({ link }) => {
    const dispatch = useDispatch();
    const itemCount = useSelector(makeGetWishlistCounter());
    const hasItems = !!itemCount && itemCount > 0;
    usePageShow(() => {
        dispatch(wishListActions.getWishListProducts());
    });
    useEffect(() => {
        dispatch(wishListActions.getWishListProducts());
    }, []);
    return (_jsxs("div", { "data-analytics-bannerid": "header-wishlist", children: [_jsx(Breakpoint, { from: "lg", children: getWishlistIcon({
                    isDesktop: true,
                    hasItems,
                    itemCount,
                    link,
                }) }), _jsx(Breakpoint, { until: "lg", children: getWishlistIcon({
                    isDesktop: false,
                    hasItems,
                    itemCount,
                    link,
                }) })] }));
};
const getWishlistIcon = ({ isDesktop, hasItems, itemCount, link }) => {
    const iconConfig = isDesktop
        ? {
            title: 'wishlist icon',
            source: HeartFillIcon,
            size: 'sm',
            color: 'brand',
            testId: 'wishlist',
        }
        : {
            title: 'wishlist icon',
            source: HeartIcon,
            size: 'sm',
            color: 'neutral',
            testId: 'wishlist',
        };
    return (_jsx(IconLink, { icon: iconConfig, testId: "wishlist-icon", tabIndex: 0, variant: "plain", ariaLabel: "wishlist button", size: "sm", href: link, children: hasItems && (_jsx(Badge, { size: "sm", color: "brandAccent", testId: "wishlist_counter", children: itemCount })) }));
};
export default WishListMenuItem;
